import { VARIABLE_NAMES } from "../variable-constants";
import { SettingsConfig } from "../settings-type";

const defaultSettings: SettingsConfig = {
  [VARIABLE_NAMES.VARIABLE_TO_TEST_WITH]: "default",
  [VARIABLE_NAMES.FAVICON_COLOR]: "blue",
  [VARIABLE_NAMES.HEAP_KEY]: "4002302631",
  [VARIABLE_NAMES.JAZZHR_BASE_URL]: "https://app.env-94.resumatorlabs.net",
  [VARIABLE_NAMES.MESH_HOST]: "https://staging.justworks.com/gqlpl",
  [VARIABLE_NAMES.OKTA_CLIENT_ID]: "0oaelxle2gQgTQbf81d7", // non-prod client ID
  [VARIABLE_NAMES.OKTA_ISSUER]:
    "https://staging-login.justworks.com/oauth2/default", // non-prod issuer
  [VARIABLE_NAMES.DROPBOX_SIGN_CLIENT_ID]: "176cc50ec7b69bdef40fd60879d6896d", // non-prod client ID
  [VARIABLE_NAMES.GLOBAL_IDENTITY_SETTINGS_URL]:
    "https://pim.nonprod.vibe.justworks.com",
  [VARIABLE_NAMES.USP_HOST]: "usp-api-sandbox.justworks.com",
  [VARIABLE_NAMES.USP_PIXEL_HOST]: "usp-sandbox.justworks.com",
  [VARIABLE_NAMES.USP_CLIENT_ID]: "e6d89b01-3dff-40c1-b16a-917485d2bed6",
  [VARIABLE_NAMES.USP_ENV]: "sandbox",
  [VARIABLE_NAMES.CLOCKWORK_HOST]: "https://clockwork.staging.justworks.io",
};

export default defaultSettings;
